/*
	TCR.offers-2.0 .js additions

Changes
	16 Nov 2018 - Copied from offers.1.0
    27 Nov 2018 - Made public
*/
TCR.offers = (function() {
  var MOD = "TCR.offers-2.0.";
  LTK.logHide.push( 'TCR.offers-2.0.' );
  // EXTERNAL functions called Plus a few additions

  function log(text) { LTK.log(text); };
  function info(text) { LTK.info(text); };
  function warning(text) {
    //tcrTrack("TCR WARNING", {title: text});
    LTK.warning("WARNING: " + text);
  };
  function error(text) {
    tcrTrack("TCR ERROR", {title: text});
    LTK.error("ERROR: " + text);
    throw(text);
  };
  function isBlank( obj ) { return LTK.isBlank( obj ); };
  function notBlank( obj ) { return LTK.notBlank( obj ); };
  function notNull( obj ) { return LTK.notNull( obj ); };
  function getJsonFromUrl( ) { return LTK.getJsonFromUrl( ); };

  //log( MOD + "JS...");

  // Globals

  
  var OFFERS = null;		// Gets set by JSON call
  
  var ELEMENT = {       // DOM Elements
    online_offer:			".online-offer",
    subscription_offer:		".subscription-offer",
    all_offers:				".all-offers"
  };

  Array.prototype.contains = function(obj) {
    var i = this.length;
    while (i--) {
      if (this[i] === obj) {
        return true;
      }
    }
    return false;
  }

  function getOffer() {
    var fn = MOD + "getOffer() ";
    var subOffer = sessionStorage.getItem( 'subscriptionOffer' );
    var onlineOffer = sessionStorage.getItem( 'onlineOffer' );
    var refCode = sessionStorage.getItem( 'refCode' );

    if( notBlank( refCode ) ) {
      var offer = { refCode: refCode, onlineOffer: onlineOffer , subOffer: subOffer };
      log( fn + "Offer: " + JSON.stringify(offer) );
      return offer;

    } else {
      return null;
    }
  };
  
 
  function clearOnlineOffer() {
    jQuery( ELEMENT.online_offer ).html( "" );
  };
  function clearSubscriptionOffer() {
    jQuery( ELEMENT.subscription_offer ).html( "" );
  };
  function clearAllOffers() {
    jQuery( ELEMENT.all_offers ).html( "" );
  };

  function displayAllOffers( offer ) {
    var fn = MOD + "displayAllOffers() ";
    var offerHTML;
    
    var offerText;
    
    if( notBlank( offer ) ) {
      if( notBlank( offer.onlineOffer ) && notBlank( offer.subOffer ) ) {
        	offerText = "You have special offers"
      } else {
        	offerText = "You have a special offer"
      }
      
      offerHTML = "<div class='b2 tcr-bg-vlight pad-20'>";
      offerHTML += "<p class='italic h2'>" + offerText
      offerHTML += " with code: <span class='b1'>" + offer.refCode + "</span></p>";
      if( notBlank( offer.onlineOffer ) ) {
        offerHTML += "<p>Online: <span class='italic'>" + offer.onlineOffer + "</span></p>";
      }
      if( notBlank( offer.subOffer ) ) {
        offerHTML += "<p><a href='/pages/subscription-service'>Subscription: </a><span class='italic'>" + offer.subOffer + "</span></p>";
      }
      offerHTML += "</div>"
      jQuery( ELEMENT.all_offers ).html( offerHTML );
    }
  };

  function displayOnlineOffer( offer ) {
    var fn = MOD + "displayOnlineOffer() ";
    var offerHTML;
    
    if( notBlank( offer ) && notBlank( offer.onlineOffer ) ) {
      offerHTML = "<div class='b2 tcr-bg-vlight pad-20'>";
      offerHTML += "<p class='italic'>" + offer.onlineOffer + "</p>";
      offerHTML += "<div class='h2'>Use code <span class='tcr-orange'>" + offer.refCode + "</span> during checkout</div>";
      offerHTML += "</div>"
      jQuery( ELEMENT.online_offer ).html( offerHTML );
    }
  };

  function displaySubscriptionOffer( offer ) {
    var fn = MOD + "displaySubscriptionOffer() ";
    var offerHTML;
    log( fn + "..." );
    
    if( notBlank( offer ) && notBlank( offer.subOffer ) ) {
      offerHTML = "<div class='b2 tcr-bg-vlight pad-20'>";
      offerHTML += "<p class='h2'>Your offer has been applied:<p/>";
      offerHTML += "<i>" + offer.subOffer + "<br/>with code " + "<span class='tcr-orange'>" + offer.refCode + "</span>";
      offerHTML += "</i></div>"
      jQuery( ELEMENT.subscription_offer ).html( offerHTML );
    }
    log( fn + "...OK" );

  };
  
  function displayOffers() {
    var fn = MOD + "displayOffers() "
    var offer = getOffer();
     
     if( notBlank( offer ) ) {
       displayAllOffers( offer );
     } else {
       clearAllOffers();
     }
    log( fn + "...OK" );
     
   };


  
  // Retrieve any referral code from URL parameters
  function getReferralCode( ) {
    var fn = MOD + "getReferralCode() "
    var queryString;
    var refCode;

    queryString = getJsonFromUrl();
    refCode = queryString.ref;
    
    if( isBlank( refCode ) ) refCode = sessionStorage.getItem( 'refCode' );

    if( notNull( refCode ) ) refCode = LTK.handleize( refCode.toLowerCase() );

    log( fn + "RefCode: " + refCode );
    return( refCode );
  };
  
  // Set Referral Code Offers - given a code, find and store (in session) relevant offers
  function setReferralOffers( refCode ) {
    var fn = MOD + "setReferralOffers() "
    var offer = null;
    var url = '/blogs/referral-codes/' + refCode;

    
    sessionStorage.removeItem( 'refCode' );	// Remove existing in case no relevant offers
    
    if( isBlank( refCode ) ) { // Remove existing if blank refCode - shouldn't be passed
      sessionStorage.removeItem( 'onlineOffer' );
      sessionStorage.removeItem( 'subscriptionOffer' );
      log( fn + "Blank refCode - cleared session storage" );
      return;
    }
    log( fn + "Getting Referral Code: " + url);
    jQuery.getJSON(url, function(code) {
      //log(fn + "Got Referral Code: " + JSON.stringify(code) );
      //log(fn + "Got Referral Code: " + code.title );
      //log(fn + "Handle: " + code.handle);
      
      //	Found a valid referral code so clear any previous offers and store it 
      sessionStorage.removeItem( 'onlineOffer' );
      sessionStorage.removeItem( 'subscriptionOffer' );
      sessionStorage.setItem( 'refCode', code.title );
      log( fn + "Referral Code: " + sessionStorage.getItem( 'refCode' ) );
        
      // Get all Offers for Referal Code
      for (var i = 0; i < code.tags.length; i++) {
        var offerCode = code.tags[i];
        var offer = null;
      	//log(fn + "OfferCode: " + offerCode );
        
        offer = OFFERS[ offerCode ];
        
        if ( notBlank( offer ) && notBlank( offer.linked_rule ) ) {
          offer = OFFERS[ offer.linked_rule ];
        }
        
        if ( isBlank( offer ) ) {
          warning( fn + "No Offer found for code: " + offerCode );
        } else {
          
          // Valid Offer
          log( fn + "Got Offer: " + offer.offer_type + ":" + offerCode + ":" + offer.name );
          switch( offer.offer_type ) {
              
            case "subscription":
              sessionStorage.setItem( 'subscriptionOffer', offer.description );
              log( fn + "Subscription Offer: " + sessionStorage.getItem( 'subscriptionOffer' ) );
              displayOffers();
              break;
              
            case "online":
              sessionStorage.setItem( 'onlineOffer', offer.description );
              log( fn + "Online Offer: " + sessionStorage.getItem( 'onlineOffer' ) );
              displayOffers();
              break;
              
            default:
              warning(fn + "Unknown Offer Type (" + offer.offer_type + ") for: " + offerCode )
          };
        }
        
        
      }
    })
 
    .fail( function() {
      warning( fn + "Failed to get Referral Code: " + url);
    });
    
    log( fn + "...OK");

  };
  

  function initReferralOffers( ) {
    var fn = MOD + "initReferralOffers() "
    var refCode = null;
    var url = "/?view=loyalty-rules-json";
    
    refCode = getReferralCode();
    if( notBlank( refCode ) ) {
      
      log( fn + "Getting all offers..." );
      jQuery.getJSON(url, function(loyalty_rules) {
        var offer = null;
        log( fn + "Got: " + loyalty_rules.title + ". " + Object.keys(loyalty_rules.metafields).length + " Offers" );
        OFFERS = loyalty_rules.metafields;
        
        // Check if referral code matches any offers & store
        setReferralOffers( refCode );
      })
      .fail( function() {
      	warning( fn + "Failed to get Offers: " + url);
      });
    }

    log( fn + "...OK");
  };

  
  
  $(document).ready(function() {
    var fn = MOD + "document.READY() ";

    log( fn + "Check for Referral Code & initialise any offers...");
    initReferralOffers();
    log( fn + "...OK");

  });

  /*
  	MAIN
  */
  var main = function() {
    var fn = MOD + "main() ";
  };
  
  main();


  //log( MOD + "JS...OK")
  //	Public methods

  return {
    getOffer: getOffer,
    displayOffers: displayOffers,
    setReferralOffers: setReferralOffers,
    clearOnlineOffer: clearOnlineOffer,
    clearSubscriptionOffer: clearSubscriptionOffer,
    displayOnlineOffer: displayOnlineOffer,
    displaySubscriptionOffer: displaySubscriptionOffer
  };

})();	// End of TCR.offers Module - IFFE pattern
